import { LinkItem } from '@occc-app/design-system';
import { AudienceCreate, AudienceTargetingAttributesInput } from '@occc/graphql';
import {
  prepareAudienceTargetingAttributesInput,
  routeCreator,
} from '@occc-app/routes/Audience/utils';
import { AudienceFormValues } from '../types';

export const getAudienceCreatePageHeaderLinks = (name: string): LinkItem[] => [
  {
    to: routeCreator.base(),
    label: 'Audiences',
  },
  {
    to: routeCreator.create(),
    label: 'Create',
  },
  {
    key: '/audiences/create/audience-name',
    label: name ? `${name}` : null,
  },
];

export const prepareAudienceCreateInput = (
  chainId: string,
  values: AudienceFormValues,
): AudienceCreate => {
  const {
    name,
    description,
    ageWithin,
    behaviors,
    purchases,
    segments,
    fulfillments,
    homeStore,
    walletSteeringItems,
    productInterests,
    qualifiedEvents,
    lastVisit,
    pointBalance,
    membershipCreated,
    employeeTargetingAttributes,
    surveys,
    combinedAudiences,
    externalIdentityVerification,
    communicationPreferences,
  } = values;

  const targetingAttributes: AudienceTargetingAttributesInput =
    prepareAudienceTargetingAttributesInput({
      ageWithin,
      behaviors,
      purchases,
      segments,
      fulfillments,
      homeStore,
      walletSteeringItems,
      productInterests,
      qualifiedEvents,
      lastVisit,
      pointBalance,
      membershipCreated,
      employeeTargetingAttributes,
      surveys,
      combinedAudiences,
      externalIdentityVerification,
      communicationPreferences,
    });

  return {
    chainId,
    name,
    description,
    targetingAttributes,
  };
};
